export const enum RetailTableColumnId {
  Name = 'name',
  Email = 'email',
  Phone = 'phone',
  DefaultPayment = 'defaultPayment',
  UnpaidBalance = 'unpaidBalance',
  UnpaidInvoices = 'unpaidInvoices',
  BillingAddress = 'billingAddress',
  ShippingAddress = 'shippingAddress',
  LastActivity = 'lastActivity',
  Notes = 'notes',
  Actions = 'actions',
}

export type CardBrand = 'visa' | 'mastercard' | 'amex' | 'discover';

export interface RetailCustomerPayment {
  brand: CardBrand;
  lastFour: string;
}

export interface RetailInvoice {
  id: number;
  label: string;
}

export interface RetailCustomer {
  id: number;
  name: string;
  email: string;
  phone: string;
  defaultPayment: RetailCustomerPayment | null;
  unpaidBalance: number;
  unpaidInvoices: RetailInvoice[];
  billingAddress: string;
  shippingAddress: string;
  lastActivity: string; // ISO date string
  notes: string;
}
